import React from "react";

/**
 * @deprecated This icon uses Macaw-UI patterns which are deprecated. Please use Lucide React icons instead.
 * @see https://lucide.dev/ for available icons
 * @example
 * import { Database } from "lucide-react";
 * // Use <Database /> instead
 */
export const Graphql = () => {
  return (
    // Mark component as candidate for macaw-ui
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 29.999 30"
      fill="currentColor"
      data-macaw-ui-candidate
    >
      <path d="M4.08 22.864l-1.1-.636L15.248.98l1.1.636z" />
      <path d="M2.727 20.53h24.538v1.272H2.727z" />
      <path d="M15.486 28.332L3.213 21.246l.636-1.1 12.273 7.086zm10.662-18.47L13.874 2.777l.636-1.1 12.273 7.086z" />
      <path d="M3.852 9.858l-.636-1.1L15.5 1.67l.636 1.1z" />
      <path d="M25.922 22.864l-12.27-21.25 1.1-.636 12.27 21.25zM3.7 7.914h1.272v14.172H3.7zm21.328 0H26.3v14.172h-1.272z" />
      <path d="M15.27 27.793l-.555-.962 10.675-6.163.555.962z" />
      <path d="M27.985 22.5a2.68 2.68 0 0 1-3.654.981 2.68 2.68 0 0 1-.981-3.654 2.68 2.68 0 0 1 3.654-.981c1.287.743 1.724 2.375.98 3.654M6.642 10.174a2.68 2.68 0 0 1-3.654.981A2.68 2.68 0 0 1 2.007 7.5a2.68 2.68 0 0 1 3.654-.981 2.68 2.68 0 0 1 .981 3.654M2.015 22.5a2.68 2.68 0 0 1 .981-3.654 2.68 2.68 0 0 1 3.654.981 2.68 2.68 0 0 1-.981 3.654c-1.287.735-2.92.3-3.654-.98m21.343-12.326a2.68 2.68 0 0 1 .981-3.654 2.68 2.68 0 0 1 3.654.981 2.68 2.68 0 0 1-.981 3.654 2.68 2.68 0 0 1-3.654-.981M15 30a2.674 2.674 0 1 1 2.674-2.673A2.68 2.68 0 0 1 15 30m0-24.652a2.67 2.67 0 0 1-2.674-2.674 2.67 2.67 0 1 1 5.347 0A2.67 2.67 0 0 1 15 5.347" />
    </svg>
  );
};
